/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RedeployRequestBody,
  RedeployRequestBody$Outbound,
  RedeployRequestBody$outboundSchema,
} from "../components/redeployrequestbody.js";

export type RedeployDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RedeployDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RedeployDeploymentSecurity = {
  option1?: RedeployDeploymentSecurityOption1 | undefined;
  option2?: RedeployDeploymentSecurityOption2 | undefined;
};

export type RedeployDeploymentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  redeployRequestBody: RedeployRequestBody;
};

/** @internal */
export type RedeployDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RedeployDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  RedeployDeploymentSecurityOption1$Outbound,
  RedeployDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function redeployDeploymentSecurityOption1ToJSON(
  redeployDeploymentSecurityOption1: RedeployDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    RedeployDeploymentSecurityOption1$outboundSchema.parse(
      redeployDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type RedeployDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RedeployDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  RedeployDeploymentSecurityOption2$Outbound,
  RedeployDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function redeployDeploymentSecurityOption2ToJSON(
  redeployDeploymentSecurityOption2: RedeployDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    RedeployDeploymentSecurityOption2$outboundSchema.parse(
      redeployDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type RedeployDeploymentSecurity$Outbound = {
  Option1?: RedeployDeploymentSecurityOption1$Outbound | undefined;
  Option2?: RedeployDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RedeployDeploymentSecurity$outboundSchema: z.ZodMiniType<
  RedeployDeploymentSecurity$Outbound,
  RedeployDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RedeployDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RedeployDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function redeployDeploymentSecurityToJSON(
  redeployDeploymentSecurity: RedeployDeploymentSecurity,
): string {
  return JSON.stringify(
    RedeployDeploymentSecurity$outboundSchema.parse(redeployDeploymentSecurity),
  );
}

/** @internal */
export type RedeployDeploymentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RedeployRequestBody: RedeployRequestBody$Outbound;
};

/** @internal */
export const RedeployDeploymentRequest$outboundSchema: z.ZodMiniType<
  RedeployDeploymentRequest$Outbound,
  RedeployDeploymentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    redeployRequestBody: RedeployRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      redeployRequestBody: "RedeployRequestBody",
    });
  }),
);

export function redeployDeploymentRequestToJSON(
  redeployDeploymentRequest: RedeployDeploymentRequest,
): string {
  return JSON.stringify(
    RedeployDeploymentRequest$outboundSchema.parse(redeployDeploymentRequest),
  );
}
